const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

const flipAnimation = () => {
  const titleContainer = document.querySelector(".title-work-container");
  const title = document.querySelector(".work-title-page");
  const leftColumn = document.querySelector(".col1");

  if (!isDesktop || !title || !leftColumn || !titleContainer) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: titleContainer,
      start: "top center",
      endTrigger: titleContainer,
      end: "bottom center",
      toggleActions: "play none none none",
      onEnter: () => {
        const state = Flip.getState(title, { props: "fontSize" });
        leftColumn.appendChild(title);
        Flip.from(state, {
          absolute: true,
          duration: 0.5,
        });
      },
    },
  });

  tl.to(".title-work-container", {
    minHeight: 0,
    delay: 0.5,
  });
};

export default flipAnimation;
